import React from "react";
import styled from "styled-components";
import { StyledText } from "../../../../components/common/basic";
import { EyeIcon, CommentIcon } from "../../../../components/svgs";
import EditIcon from "../../../../components/svgs/editIcon";
import { getRelativeTimeAgo } from "../../../../lib/getRelativeTimeAgo";

const TopicCard = ({
  backgroundImage,
  title,
  icon,
  category,
  onClick,
  margin,
  categoryButtonColor = "#F5821E",
  numberOfViews = 0,
  numberOfComments = 0,
  isEditable = false,
  onEdit,
  datePosted,
}) => {
  return (
    <Wrapper $margin={margin} onClick={() => onClick()}>
      <Image src={backgroundImage} />
      <Gradient>
        <CardDetails>
          {isEditable && (
            <StyledEditIcon
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
            >
              <EditIcon />
            </StyledEditIcon>
          )}
          <Body>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: categoryButtonColor,
                width: "fit-content",
                justifyContent: "space-around",
                borderRadius: "40px",
                height: "24px",
                paddingInline: 10,
                gap: "3px",
              }}
            >
              <div>{icon}</div>
              <div>
                <StyledText
                  size={12}
                  color={"white"}
                  style={{ width: "90%", margin: 0 }}
                >
                  {category}
                </StyledText>
              </div>
            </div>
            <StyledText style={{ marginBlockEnd: 0 }} size={12} color={"white"}>
              {title}
            </StyledText>
            <IconsWrapper>
              <IconsContainer>
                <EyeIcon isVisible fill={"white"} width={28} height={22} />
                <StyledText
                  size={12}
                  color={"white"}
                  style={{ width: "90%", marginLeft: 5 }}
                >
                  {numberOfViews}
                </StyledText>
              </IconsContainer>
              <IconsContainer>
                <CommentIcon />
                <StyledText
                  size={12}
                  color={"white"}
                  style={{ width: "90%", marginLeft: 5 }}
                >
                  {numberOfComments}
                </StyledText>
              </IconsContainer>
              <IconsContainer>
                {/* <CommentIcon /> */}
                <StyledText
                  size={12}
                  color={"white"}
                  style={{ width: "100%", marginLeft: 5 }}
                >
                  {getRelativeTimeAgo(datePosted)}
                </StyledText>
              </IconsContainer>
            </IconsWrapper>
          </Body>
        </CardDetails>
      </Gradient>
    </Wrapper>
  );
};

const StyledEditIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 7.86px;
  padding: 10px;
  cursor: pointer;
`;

const Wrapper = styled.div`
  width: 350px;
  height: 200px;
  border-radius: 20px;
  margin: ${(props) => props.$margin || "10px"};
  position: relative;
`;

const Image = styled.img`
  width: 350px;
  height: 200px;
  object-fit: cover;
  position: absolute;
  border-radius: 20px;
`;

const Gradient = styled.div`
  width: 350px;
  height: 200px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: relative;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-end;
`;

const Body = styled.div`
  box-sizing: border-box;
  max-width: 210px;
  padding: 10px;
`;

const CardDetails = styled.div``;

const IconsWrapper = styled.div`
  display: flex;
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
`;

TopicCard.defaultProps = {
  tag: "Loyalty",
  title: "Pulse & Chill",
  description:
    "Just keep talking and browsing to rack up points and you could be the winner! ",
};

export default TopicCard;
